import React, {useState, useEffect, Fragment} from 'react'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext'
import './StaffPage.css'
import './StudentClassStudentAdminPage.css'
import './DispatchedExams.css'

export default function DispatchedExams(){
    const {user} = useAuth()
    const schoolID = user.scId
    const [testGroups, setTestGroups] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [displayTestGroups, setDisplayTestGroups] = useState([])
    const [studentsWithExams, setStudentsWithExams] = useState([])
    const [currentTestType, setCurrentTestType] = useState('ALLE')
    const [searchTerm, setSearchTerm] = useState('')

    async function fetchTestGroups(){
        try{
            console.log(" i dispath er skole: " + schoolID)
            const result = await apiClient.get('/api/testgroup/getalldispatched', 
                {params: {schoolID : schoolID}}
            )
            setTestGroups(result.data)
            setDisplayTestGroups(result.data)
        }catch(e){
            console.log("fejl ved fetch af test groups")
            console.log(e)
        }
    }

    async function fetchStudentsWithExams(){
        try{
            const result = await apiClient.get('/api/testgroup/getstudentswithexams',
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
            setStudentsWithExams(result.data)
            console.log("Det lykkedes med at få studerner ")
            console.log(result?.data?.rowCount)

        }catch(e){
            console.log(" error in getting students with exams")
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchTestGroups()
        fetchStudentsWithExams()
    }, [currentTestGroup])

    useEffect(()=>{
        const filteredTestGroupArray = testGroups.filter(tg => 
            {
                if(!(tg.studie === currentTestType || currentTestType ==='ALLE')) return false;
                const haystack = (tg.navn+tg.studie+tg.sprogcenter_navn).toLowerCase()
                if(!haystack.includes(searchTerm.toLowerCase())) return false;
                return true;
            })
        setDisplayTestGroups(filteredTestGroupArray)
    }, [currentTestType, searchTerm, testGroups])

    async function handleDownload(filename){
        try{
            const res = await apiClient.get('/api/downloadfile', {
                params: {filename},
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(res.data)
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        }catch(e){
            console.log("fejl ved download af fil")
            console.log(e)
        }
    }

    return(
        <div className="panel-container dispatched-exams-page">
            <div className="panel">
                <div className="table-bar">
                    <input 
                        type="text"
                        className="search-input"
                        placeholder="Søg..."
                        value={searchTerm}
                        onChange={(e)=>setSearchTerm(e.target.value)}
                    />
                    <select
                        value={currentTestType}
                        onChange={(e) =>setCurrentTestType(e.target.value)}
                        aria-label="Filtrér efter prøvetype"
                    >
                        <option key="ALLE" value="ALLE">Alle</option>
                        <option key="PD1" value="PD1">PD1</option>
                        <option key="PD2" value="PD2">PD2</option>
                        <option key="PD3" value="PD3">PD3</option>
                    </select>
                </div>
                <table className="censor-table">
                    <thead>
                        <tr>
                            <th>Prøveform</th>
                            <th>Modtager sprogcenter</th>
                            <th>Prøvegruppe</th>
                            <th>Filnavn</th>
                            <th>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {displayTestGroups.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="drop-zone-hint dispatched-muted">
                                    Ingen afsendte prøvegrupper
                                </td>
                            </tr>
                        ) : (
                            displayTestGroups.map(tg => (
                                <Fragment key={tg.id}>
                                    <tr>
                                        <td>{tg.studie}</td>
                                        <td>{tg.sprogcenter_navn}</td>
                                        <td>{tg.navn}</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    {(!tg?.examupload_filenames || tg.examupload_filenames.length === 0) ? 
                                    (
                                        <tr>
                                            <td colSpan={3} />
                                            <td colSpan={2} className="dispatched-muted">Ingen uploadede filer</td>
                                        </tr>
                                    ):(                                    
                                      tg.examupload_filenames.map((fileName) => (
                                        <tr key={`${tg.id}-${fileName}`}>
                                            <td colSpan={3} />
                                            <td>
                                                <div className="upload-file-name">{fileName}</div>
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="tg-table-action"
                                                    onClick={()=>handleDownload(fileName)}
                                                >
                                                    Download
                                                </button>
                                            </td>
                                        </tr>
                                        ))                                
                                    )
                                    }
                                </Fragment>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
